import { Button, TextField } from '@mui/material'
import React, { useRef, useState } from 'react'
import { forgotPassword } from '../../../API/generalAPI'
import { useDomain } from '../../../Context/DomainContext'
import LoadingModal from '../Loading/LoadingModal'
import FormContainer from '../WindowContainer'

const Forgotpassword = () => {
  const usernameRef = useRef('')

  const { strippedDomain } = useDomain()

  const [errorMessage, setErrorMessage] = useState('')

  const [isLoading, setIsLoading] = useState(false)

  const handlePasswordReset = () => {
    setIsLoading(true)
    forgotPassword(usernameRef.current.value, strippedDomain)
      .then((response) => {
        if (response.data.ttStdRes[0].lSuccess) {
          setErrorMessage('')
        } else {
          setErrorMessage(response.data.ttStdRes[0].cErrorMsg)
        }
      })
      .catch((error) => {})
      .then(() => {
        setIsLoading(false)
      })
  }

  return (
    <FormContainer>
      {isLoading && <LoadingModal message={'Please Wait While We Email You'} />}
      <h1>Forgot Password</h1>
      <p>
        Enter your username in the field below and click the "reset" button so
        that a new temporary password can be emailed to you.
      </p>
      <p style={{ color: 'Red' }}>{errorMessage}</p>
      <div>
        <TextField inputRef={usernameRef} label={'Username'} />
      </div>
      <div>
        <Button variant="contained" onClick={handlePasswordReset}>
          Reset Password
        </Button>
      </div>
      <a href={'/'}>Back To Login</a>
    </FormContainer>
  )
}

export default Forgotpassword
